import { render, staticRenderFns } from "./basic.vue?vue&type=template&id=570c5a24&scoped=true"
import script from "./basic.vue?vue&type=script&lang=js"
export * from "./basic.vue?vue&type=script&lang=js"
import style0 from "./basic.vue?vue&type=style&index=0&id=570c5a24&prod&lang=css"
import style1 from "./basic.vue?vue&type=style&index=1&id=570c5a24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570c5a24",
  null
  
)

export default component.exports